import type { Permission } from '@/api';
import { useAuthContext } from '@/context/auth-context';
import { useUserPermissions } from '@/pages/queries';

export const useHasPermissions = (
  requiredPermissions: Permission[],
  match: 'all' | 'some' = 'all',
): boolean => {
  const { isApiClientReady, user } = useAuthContext();
  const { data: userPermissions } = useUserPermissions(
    user?.accountId,
    user?.roles ?? [],
    isApiClientReady,
  );

  if (match === 'all') {
    return requiredPermissions.every((p) => userPermissions?.includes(p));
  }
  return requiredPermissions.some((p) => userPermissions?.includes(p));
};
